<template>
  <tr>
    <td class="a">{{ index }}</td>
    <td>{{ inputs.reference_document.name }}</td>
    <td class="c">
      <app-input
        type="textarea"
        v-model="inputs.observations"
        placeholder="Ingrese las observaciones"
      />
    </td>
    <td class="d">
      <app-input
        type="radio-buttons"
        v-model="inputs.is_checked"
        :list="isChecked"
      />
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    index: Number,
    inputs: Object,
  },
  data() {
    return {
      isChecked: [
        {
          id: "0",
          value: "NO",
        },
        {
          id: "1",
          value: "SI",
        },
      ],
    };
  },
};
</script>